import { ChangeDetectionStrategy, Component, computed, HostBinding, Input, signal } from '@angular/core';

import { TreeDragDropInstruction, TreeDragDropInstructionType } from '../tree-drag-drop.service';

@Component({
  selector: 'tt-tree-drag-drop-indicator',
  standalone: true,
  imports: [],
  template: ``,
  styleUrl: './tree-drag-drop-indicator.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TreeDragDropIndicatorComponent {
  private _instruction = signal<TreeDragDropInstruction | undefined>(undefined);
  @Input() public set instruction(value: TreeDragDropInstruction | undefined) {
    this._instruction.set(value);
  }

  @HostBinding('class')
  public get hostCls() {
    return this._hostCls();
  }

  @HostBinding('style')
  public get style() {
    return this._style();
  }

  protected _style = computed(() => {
    const instruction = this._instruction();
    if (!instruction) return {};

    const indent = instruction.currentLevel * instruction.indentPerLevel;

    return {
      '--horizontal-indent': `${indent}px`,
      '--indicator-color': 'var(--indicator-color-primary)',
    };
  });

  protected _hostCls = computed(() => {
    switch (this.instructionType()) {
      case TreeDragDropInstructionType.ReorderAbove:
        return ['tt-tree-drag-indicator--line', 'tt-tree-drag-indicator--line-above'];
      case TreeDragDropInstructionType.ReorderBelow:
        return ['tt-tree-drag-indicator--line', 'tt-tree-drag-indicator--line-below'];
      case TreeDragDropInstructionType.MakeChild:
        return 'tt-tree-drag-indicator--outline';
      case TreeDragDropInstructionType.Blocked:
        return 'tt-tree-drag-indicator--blocked';
    }
  });

  protected instructionType = computed(() => {
    const instruction = this._instruction();

    if (!instruction) return;

    return instruction.type;
  });
}
